export class SIQNavigationTheme {
  backgroundColor = "null";
  titleColor = "null";
  tintColor = "null";
}
//# sourceMappingURL=SIQNavigationTheme.js.map